import {
    ConsentLevel,
    mapSophiBreadcrumb,
    useConsentGiven,
} from '@news-mono/web-common'
import React from 'react'
import { AmpAnalytics } from '../analytics'

export interface AmpSophiProps {
    primaryTopicId: string
    publicationDate: string
    /** Top most primary topic */
    sectionName: string
    kind: 'redirect' | 'article' | 'gallery'
    publicationId: string
}

export const AmpSophi: React.FC<AmpSophiProps> = ({
    primaryTopicId,
    publicationDate,
    sectionName,
    kind,
    publicationId,
}) => {
    const consentGiven = useConsentGiven({
        consentRequiredLevel: ConsentLevel.Analytics,
    })
    const appId = 'wan:thewest_com_au:amp'

    if (!consentGiven) {
        return null
    }

    const sophiCustomContexts = [
        {
            schema: 'iglu:com.globeandmail/environment/jsonschema/1-0-9',
            data: {
                client: 'wan',
                environment: 'prod',
            },
        },
        {
            schema: 'iglu:com.globeandmail/page/jsonschema/1-0-10',
            data: {
                type: 'article',
                breadcrumb: mapSophiBreadcrumb(primaryTopicId),
                sectionName: sectionName,
                datePublished: publicationDate,
            },
        },
        {
            schema: 'iglu:com.globeandmail/content/jsonschema/1-0-12',
            data: {
                type: kind,
                contentId: publicationId,
            },
        },
    ]

    const sophiConfig = {
        vars: {
            collectorHost: 'collector.sophi.io',
            appId: appId,
            customContexts: JSON.stringify(sophiCustomContexts),
            linkers: {
                enabled: true,
                proxyOnly: false,
                destinationDomains: ['thewest.com.au'],
            },
        },
        triggers: {
            defaultPageview: { on: 'visible', request: 'pageView' },
            trackFirstPagePing: {
                on: 'timer',
                request: 'pagePing',
                timerSpec: {
                    interval: 5,
                    maxTimerLength: 4.99,
                    immediate: false,
                    startSpec: { on: 'visible', selector: ':root' },
                    stopSpec: { on: 'hidden', selector: ':root' },
                },
            },
            trackPagePings: {
                on: 'timer',
                request: 'pagePing',
                timerSpec: {
                    interval: 20,
                    maxTimerLength: 1800,
                    immediate: false,
                    startSpec: { on: 'visible', selector: ':root' },
                    stopSpec: { on: 'hidden', selector: ':root' },
                },
            },
        },
    }

    return (
        <AmpAnalytics
            type="snowplow_v2"
            id="sophi"
            data-credentials="include"
            dangerouslySetInnerHTML={{
                __html: `
                <script type="application/json">
                    ${JSON.stringify(sophiConfig)}
                </script>`,
            }}
        ></AmpAnalytics>
    )
}
